module.exports = __webpack_public_path__ + "static/media/member-top.06371724.png";